import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./questionReport.module.css";
import {
  TQuestionnaire,
  TQuestionnaireQuestion,
} from "../../services/types/user.types";

function QuestionReport({
  report,
}: {
  report: { questionnaire: TQuestionnaire; results: TQuestionnaireQuestion[] };
}) {
  return (
    <ul className={`${styles.list} scroll scroll_thin scroll_rounded`}>
      <li className={` ${styles.li} ${styles.li_header}`}>
        <p className={styles.text}>{t('QUESTION')}</p>
        <p className={styles.text}>{t('ANSWER')}</p>
        <p className={styles.text}>{t('SCORE')}</p>
      </li>
      {report.results.length > 0 ? (
        report.results.map((q, index) => (
          <li key={index} className={styles.li}>
            <p className={styles.text}>{q.Desc}</p>
            {q.DataTypesId === 10 && q.Answer?.startsWith("data:image/png") ? (
              <img
                src={q.Answer}
                alt={t('SIGNATURE_IMAGE')}
                className={styles.signatureImg}
              />
            ) : (
              <p className={styles.text}>{q.Answer || "-"}</p>
            )}
            <p className={styles.text}>{q.Score}</p>
          </li>
        ))
      ) : (
        <p className={styles.noResults}>{t('NO_RESULTS_FOUND')}</p>
      )}
    </ul>
  );
}

export default QuestionReport;